import React from 'react';
import {
	ExperienceStart,
	ExperienceSuccess,
	useExperienceFail,
} from '@atlassian/jira-experience-tracker';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller';

const VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME = 'viewDeploymentsEmptyStateTutorial';
const VIEW_DEPLOYMENTS_EXPERIENCE_NAME = 'viewDeployments';

export const ViewDeploymentsEmptyStateTutorialExperienceStart = ({
	experienceId,
}: {
	experienceId: string | null;
}) => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME}
			analyticsSource="deploymentsEmptyStateTutorial"
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

type OnExperienceFail = (location: string, error: Error) => void;

/**
 * The function returned by this hook should be called if an "unexpected error"
 * occurs, e.g. a JavaScript exception bubbles out of the Deployments empty state tutorial
 */
export const useViewDeploymentsEmptyStateTutorialExperienceFail = (): OnExperienceFail => {
	const onViewDeploymentsEmptyStateTutorialFailure = useExperienceFail({
		experience: VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME,
	});
	// TODO: Deduplicate this call when the entire empty state page is migrated to Relay
	// https://softwareteams.atlassian.net/browse/RLSS-2722
	const onViewDeploymentsFailure = useExperienceFail({
		experience: VIEW_DEPLOYMENTS_EXPERIENCE_NAME,
		attributes: { hasDeployments: false },
	});

	return (location: string, error: Error) => {
		onViewDeploymentsEmptyStateTutorialFailure(location, error);
		onViewDeploymentsFailure(location, error);
	};
};

/**
 * Fires two success events for when the empty state tutorial is successfully rendered
 *   1. As a standalone component via the meatball menu i.e. modal
 *   2. As part of the deployments page empty state i.e. static component
 */
export const ViewDeploymentsEmptyStateTutorialExperienceSuccessTracker = () => {
	const { data } = useProjectContext();
	const { projectId, isProjectAdmin, simplified } = data ?? {};

	return (
		<>
			<ExperienceSuccess
				experience={VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME}
				// @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'.
				attributes={{ projectId, isProjectAdmin, simplified }}
			/>
			<ExperienceSuccess
				experience={VIEW_DEPLOYMENTS_EXPERIENCE_NAME}
				// @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'.
				attributes={{ projectId, isProjectAdmin, simplified, hasDeployments: false }}
			/>
		</>
	);
};
